import { computed, runInAction, decorate, observable } from "mobx";
import moment from "moment";
const Guid = require("uuid/v4");

export default class Model {
  Id = null;
  store = null;
  constructor(store, id = Guid()) {
    this.store = store;
    this.Id = id;
    this.SaveError = null;
    this.LockId = null;
    this.LastUpdated = null;
  }

  get LastUpdatedDisplayValue() {
    let displayValue = "";
    if (this.LastUpdated) {
      displayValue = moment(this.LastUpdated).format("L LTS");
    }
    return displayValue;
  }

  get isNew() {
    return this.LastUpdated ? false : true;
  }

  mapToObject(key) {
    return this;
  }

  parseAsDate(key) {
    return false;
  }

  parseValue(key, value) {
    if (value) {
      if (this.parseAsDate(key)) value = moment(value);
    }
    return value;
  }

  updateFromJson(json, idKey = "Id") {
    runInAction(() => {
      const keys = Object.keys(json);
      if (keys && keys instanceof Array) {
        keys.forEach(key => {
          if (key !== idKey) {
            let value = json[key];
            value = this.parseValue(key, value);
            const mappedObject = this.mapToObject(key);
            mappedObject[key] = value;
          }
        });
      }
    });
  }
}

decorate(Model, {
  SaveError: observable,
  LockId: observable,
  LastUpdated: observable,
  LastUpdatedDisplayValue: computed,
  isNew: computed
});



// WEBPACK FOOTER //
// ./src/Core/Stores/ModelStore/Model.js